import { enUS, vi, km, hi, id, ms, th, zhTW } from 'date-fns/locale';
import './index-57001be3.js';
import { siteHost, siteOptions } from './constantsSite.js';
import { domainLocales, MAP_DOMAIN_BY_LOCALE } from './constantsDomainLocales.js';
import { RISK_SCREENER_NAME, RISK_SCREENER_SLUG } from './constantsRiskScreener.js';
import { isProduction } from './constantsIsProduction.js';
import { L as LOCALE } from './Locale-e37edea6.js';

const basePath = process.env.NEXT_PUBLIC_DEPLOY_LOCALE === 'tl-PH' ? '/fil' : '';
const SSO_URL = process.env.NEXT_PUBLIC_SSO;
const USER_GEOLOCATION_COORDINATES_COOKIE = 'userGeoLocationCoordinates';
const LOCALE_SPECS = {
    'vi-VN': {
        PHONE: '+84',
        LOGO_TYPE: 'hellobacsi',
        SITE_NAME: 'HelloBacsi',
        SITE_NAME_FORMATTED: 'Hello Bacsi',
        HOMEPAGE_IMAGE: 'https://hellobacsi.com/images/country-thumbnails/VN.png',
        SITE_ID: '1',
        INSIDER_TAG: '//hellobacsivn.api.useinsider.com/ins.js?id=10003798',
        TOOLTIP_IMAGE: '/images/tooltips-vn.png',
        PREGNANCY_WEIGHT_GAIN: 'cong-cu-tinh-can-nang-khi-mang-thai',
        BABY_POOP: 'phan-tre-so-sinh-nhu-the-nao-la-tot',
        VACCINATION_TOOL: 'lich-tiem-chung',
    },
    'en-PH': {
        PHONE: '+63',
        LOGO_TYPE: 'hellodoctor',
        SITE_NAME: 'HelloDoctor',
        HOMEPAGE_IMAGE: 'https://hellodoctor.com.ph/images/country-thumbnails/PH.png',
        SITE_NAME_FORMATTED: 'Hello Doctor',
        SITE_ID: '9',
        CATEGORIES_TYPE: 'short',
        INSIDER_TAG: '//hellodoctorph.api.useinsider.com/ins.js?id=10004527',
        TOOLTIP_IMAGE: '/images/tooltips-ph.png',
        PREGNANCY_WEIGHT_GAIN: 'pregnancy-weight-gain-calculator',
        BABY_POOP: 'a-visual-guide-on-baby-poop',
        VACCINATION_TOOL: 'vaccination-tool',
    },
    'th-TH': {
        PHONE: '+66',
        LOGO_TYPE: 'hellokhunmor',
        SITE_NAME: 'HelloKhunmor',
        HOMEPAGE_IMAGE: 'https://hellokhunmor.com/images/country-thumbnails/TH.png',
        SITE_NAME_FORMATTED: 'Hello Khunmor',
        SITE_ID: '3',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//hellokhunmor.api.useinsider.com/ins.js?id=10004524',
        TOOLTIP_IMAGE: '/images/tooltips-th.png',
        PREGNANCY_WEIGHT_GAIN: 'เครื่องคำนวณน้ำหนักตัว',
        BABY_POOP: 'สีอุจจาระของลูก-บอกถึงส',
        VACCINATION_TOOL: 'vaccination-tool',
    },
    'km-KH': {
        PHONE: '+855',
        LOGO_TYPE: 'hellokrupet',
        SITE_NAME: 'HelloKrupet',
        HOMEPAGE_IMAGE: 'https://hellokrupet.com/images/country-thumbnails/KH.JPG',
        SITE_NAME_FORMATTED: 'Hello Krupet',
        SITE_ID: '4',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//hellokrupet.api.useinsider.com/ins.js?id=10004523',
        TOOLTIP_IMAGE: '/images/tooltips-kh.png',
        PREGNANCY_WEIGHT_GAIN: 'រង្វាស់សុខភាព/គណនាទម្ងន់ស្ត្រីពពោះ',
        BABY_POOP: 'រង្វាស់សុខភាព/អត្ថន័យពណ៌-និងរូបរាងលាម',
        VACCINATION_TOOL: 'រង្វាស់សុខភាព/កាលវិភាគចាក់ថ្នាំបង្កា',
    },
    'my-MM': {
        PHONE: '+95',
        LOGO_TYPE: 'hellosayarwon',
        SITE_NAME: 'HelloSayarwon',
        HOMEPAGE_IMAGE: 'https://hellosayarwon.com/images/country-thumbnails/PH.png',
        SITE_NAME_FORMATTED: 'Hello Sayarwon',
        SITE_ID: '7',
        INSIDER_TAG: '//hellosayarwon.api.useinsider.com/ins.js?id=10004522',
    },
    'zh-TW': {
        PHONE: '+886',
        LOGO_TYPE: 'helloyishi',
        SITE_NAME: 'HelloYishi',
        HOMEPAGE_IMAGE: 'https://helloyishi.com.tw/images/country-thumbnails/TW.png',
        SITE_NAME_FORMATTED: 'Hello Yishi',
        SITE_ID: '6',
        INSIDER_TAG: '//helloyishi.api.useinsider.com/ins.js?id=10004526',
        TOOLTIP_IMAGE: '/images/tooltips-tw.png',
        PREGNANCY_WEIGHT_GAIN: 'pregnancy-weight-gain-calculator',
        BABY_POOP: 'how-does-babies-poop-look-like',
        VACCINATION_TOOL: 'vaccination-tool',
    },
    // TODO: update info later
    'zh-CN': {
        PHONE: '',
        LOGO_TYPE: 'hellojiankang',
        SITE_NAME: 'Hello健康',
        HOMEPAGE_IMAGE: '',
        SITE_NAME_FORMATTED: 'Hello 健康',
        SITE_ID: '12',
        INSIDER_TAG: '',
        TOOLTIP_IMAGE: '',
        PREGNANCY_WEIGHT_GAIN: 'pregnancy-weight-gain-calculator',
        BABY_POOP: 'how-does-babies-poop-look-like',
        VACCINATION_TOOL: 'vaccination-tool',
    },
    'id-ID': {
        PHONE: '+62',
        LOGO_TYPE: 'hellosehat',
        SITE_NAME: 'HelloSehat',
        HOMEPAGE_IMAGE: 'https://hellosehat.com/images/country-thumbnails/ID.png',
        SITE_NAME_FORMATTED: 'Hello Sehat',
        SITE_ID: '2',
        INSIDER_TAG: '//hellosehat.api.useinsider.com/ins.js?id=10003799',
        TOOLTIP_IMAGE: '/images/tooltips-id.png',
        PREGNANCY_WEIGHT_GAIN: 'kalkulator-kenaikan-berat-badan-ibu-hamil',
        BABY_POOP: 'warna-feses-bayi-normal',
        VACCINATION_TOOL: 'jadwal-imunisasi',
    },
    'hi-IN': {
        PHONE: '+91',
        LOGO_TYPE: 'helloswasthya',
        SITE_NAME: 'HelloSwasthya',
        HOMEPAGE_IMAGE: 'https://helloswasthya.com/images/country-thumbnails/IN.png',
        SITE_NAME_FORMATTED: 'हैलो स्वास्थ्य',
        SITE_ID: '8',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//helloswasthya.api.useinsider.com/ins.js?id=10004498',
        TOOLTIP_IMAGE: '/images/tooltips-in.png',
        PREGNANCY_WEIGHT_GAIN: 'garbhavastha-weight-calculator',
        BABY_POOP: 'visual-guide-on-baby-poop',
        VACCINATION_TOOL: 'vaccination-tool',
    },
    'ms-MY': {
        PHONE: '+60',
        LOGO_TYPE: 'hellodoktor',
        SITE_NAME: 'HelloDoktor',
        HOMEPAGE_IMAGE: 'https://hellodoktor.com/images/country-thumbnails/MY.png',
        SITE_NAME_FORMATTED: 'Hello Doktor',
        SITE_ID: '5',
        INSIDER_TAG: '//hellodoktor.api.useinsider.com/ins.js?id=10004525',
        TOOLTIP_IMAGE: '/images/tooltips-my.png',
        PREGNANCY_WEIGHT_GAIN: 'kalkulator-tambah-berat-badan-hamil',
        BABY_POOP: 'kenali-najis-bayi-anda',
        VACCINATION_TOOL: 'alat-kesihatan-vaksin',
    },
    'tl-PH': {
        PHONE: '+63',
        LOGO_TYPE: 'hellodoctor',
        SITE_NAME: 'HelloDoctor',
        HOMEPAGE_IMAGE: 'https://hellodoctor.com.ph/images/country-thumbnails/PH.png',
        SITE_NAME_FORMATTED: 'Hello Doctor',
        SITE_ID: '9',
        CATEGORIES_TYPE: 'short',
        INSIDER_TAG: '//hellodoctorph.api.useinsider.com/ins.js?id=10004527',
        TOOLTIP_IMAGE: '/fil/images/tooltips-ph.png',
        PREGNANCY_WEIGHT_GAIN: 'pregnancy-weight-gain-calculator',
        BABY_POOP: 'a-visual-guide-on-baby-poop',
        VACCINATION_TOOL: 'vaccination-tool',
        ABOUT_US_IMAGE: '/fil/images/aboutus/PH.png',
    },
};
const STATIC_PAGES = {
    'vi-VN': {
        PRIVACY: '/privacy',
        TERM_OF_USE: '/dieu-khoan-su-dung',
        PRIVACY_POLICY: '/chinh-sach-quyen-rieng-tu',
        EDITORIAL_CORRECTIONS_POLICY: '/chinh-sach-bien-tap-chinh-sua',
        ADVERTISING_SPONSOR_POLICY: '/chinh-sach-quang-cao-tai-tro',
        POLICIES: '/chinh-sach',
        FAQS: '/thong-tin-quan-trong',
        SITEMAP: '/sitemap',
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/quang-cao-voi-chung-toi',
        CONTACT_US: '/lien-he',
        ABOUT_GO_CARE: '/about-go-care',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/hello-bacsi/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/tieu-chuan-cong-dong',
        TOGETHER: '/community',
    },
    'km-KH': {
        POLICIES: '/policies',
        TERM_OF_USE: '/ខនិងលក្ខខណ្ឌ',
        PRIVACY_POLICY: '/គោលការណ៍ឯកជនភាព',
        EDITORIAL_CORRECTIONS_POLICY: '/គោលការណ៍ខ្លឹមសារមាតិកា',
        ADVERTISING_SPONSOR_POLICY: '/គោលការណ៍ផ្សាយពាណិជ្ជកម',
        FAQS: '/faqs',
        SITEMAP: '/sitemap',
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/advertisement',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: '/about-go-care',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: '/#',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/គោលការណ៍ណែនាំសហគមន៍',
        TOGETHER: '/community',
    },
    'en-PH': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/community-guidelines',
        TOGETHER: '/community',
    },
    'my-MM': {
        POLICIES: '/polisi-terma-syarat',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/pengiklanan',
        CONTACT_US: '/hubungi-kami',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: ' https://hellohealthgroup.com/hello-doktor/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/panduan-komuniti',
        TOGETHER: '/community',
    },
    'zh-TW': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/advertising',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        FACILITY: '/facility',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: null,
        TOGETHER: '/community',
    },
    'zh-CN': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/advertising',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        FACILITY: '/facility',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: null,
        TOGETHER: '/community',
    },
    'id-ID': {
        POLICIES_EN: '/policies',
        TERM_OF_USE: '/kebijakan-pengguna',
        PRIVACY_POLICY: '/kebijakan-privasi',
        EDITORIAL_CORRECTIONS_POLICY: '/kebijakan-editorial',
        ADVERTISING_SPONSOR_POLICY: '/kebijakan-iklan',
        POLICIES: '/kebijakan',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/kontak-kami',
        CONTACT_EN: '/contact',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/hello-sehat/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        EDITORIAL_POLICY: '/edit-id',
        EDITORIAL_POLICY_EN: '/edit-en',
        COMMUNITY_GUIDELINE: '/panduan-komunitas',
        TOGETHER: '/community',
    },
    'hi-IN': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: null,
        TOGETHER: '/community',
    },
    'ms-MY': {
        POLICIES: '/polisi-terma-syarat',
        TERM_OF_USE: '/terma-dan-syarat',
        PRIVACY_POLICY: '/polisi-privasi',
        EDITORIAL_CORRECTIONS_POLICY: '/polisi-editorial',
        ADVERTISING_SPONSOR_POLICY: '/polisi-pengiklanan',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/pengiklanan',
        CONTACT_US: '/hubungi-kami',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: ' https://hellohealthgroup.com/hello-doktor/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/panduan-komuniti',
        TOGETHER: '/community',
    },
    'th-TH': {
        POLICIES_EN: '/policies',
        TERM_OF_USE: '/เงื่อนใขการใช้งาน',
        PRIVACY_POLICY: '/นโยบายความเป็นส่วนตัว',
        EDITORIAL_CORRECTIONS_POLICY: '/นโยบายบรรณธิการ',
        ADVERTISING_SPONSOR_POLICY: '/นโยบายการโฆษณาและผู้สนับสนุน',
        POLICIES: '/นโยบาย',
        FAQS: '/คำถามที่พบบ่อย',
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/ลงโฆษณากับเรา',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: null,
        TOGETHER: '/community',
    },
    'tl-PH': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        COMMUNITY_GUIDELINE: '/community-guidelines',
        TOGETHER: '/community',
    },
};
const UP_BASEPATH = 'user';
const TOGETHER_LOCALES = [
    'vi-VN',
    'id-ID',
    'en-PH',
    'tl-PH',
    'th-TH',
    'ms-MY',
    'my-MM',
];
const ECOM_LOCALES = ['vi-VN'];
const DATA_PRIVACY_LOCALES = ['id-ID'];
const CARE_LOCALES = [
    'vi-VN',
    'id-ID',
    // 'en-PH',
    // 'tl-PH',
    'ms-MY',
    //  'zh-TW'
];
const CARE_BOOKING_LOCALES = ['vi-VN', 'id-ID'];
const VIDEO_LOCALES = ['vi-VN'];
const FAVICONS = {
    'vi-VN': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'km-KH': [
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/km-KH/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/km-KH/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/km-KH/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/km-KH/icon-270x270.png',
        },
    ],
    'en-PH': [
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/en-PH/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/en-PH/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon',
            href: '/by-locales/en-PH/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/en-PH/icon-270x270.png',
        },
    ],
    'id-ID': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'ms-MY': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'th-TH': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'my-MM': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'zh-TW': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'hi-IN': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    marryBaby: [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/favicons/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/favicons/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/favicons/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/favicons/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/favicons/icon-180x180.png',
        },
    ],
};
var QUERY_HEALTH_TOOL;
(function (QUERY_HEALTH_TOOL) {
    QUERY_HEALTH_TOOL["bmi"] = "mi";
    QUERY_HEALTH_TOOL["gender"] = "gndr";
    QUERY_HEALTH_TOOL["age"] = "ge";
    QUERY_HEALTH_TOOL["slug"] = "slug";
    QUERY_HEALTH_TOOL["resultId"] = "resultId";
    QUERY_HEALTH_TOOL["bmr"] = "mr";
    QUERY_HEALTH_TOOL["height"] = "gt";
    QUERY_HEALTH_TOOL["weight"] = "wght";
    QUERY_HEALTH_TOOL["source"] = "surc";
    QUERY_HEALTH_TOOL["type"] = "tp";
    QUERY_HEALTH_TOOL["startDate"] = "sd";
    QUERY_HEALTH_TOOL["additional"] = "tnl";
    QUERY_HEALTH_TOOL["week"] = "wk";
    QUERY_HEALTH_TOOL["twins"] = "twn";
    QUERY_HEALTH_TOOL["weightBefore"] = "wb";
    QUERY_HEALTH_TOOL["yourself"] = "yrslf";
    QUERY_HEALTH_TOOL["intensity"] = "sy";
    QUERY_HEALTH_TOOL["rate"] = "rt";
    QUERY_HEALTH_TOOL["method"] = "mthd";
    QUERY_HEALTH_TOOL["day"] = "dy";
    QUERY_HEALTH_TOOL["pwg"] = "pwg";
    QUERY_HEALTH_TOOL["cycle"] = "le";
    QUERY_HEALTH_TOOL["period"] = "prd";
    QUERY_HEALTH_TOOL["access_token"] = "tkn";
    QUERY_HEALTH_TOOL["name"] = "nm";
    QUERY_HEALTH_TOOL["id"] = "id";
    QUERY_HEALTH_TOOL["activityLevel"] = "actl";
    QUERY_HEALTH_TOOL["status"] = "status";
    QUERY_HEALTH_TOOL["birthday"] = "brd";
})(QUERY_HEALTH_TOOL || (QUERY_HEALTH_TOOL = {}));
// Available locale list https://cdn.jsdelivr.net/npm/dayjs@1/locale.json
const ISO_FORMAT = {
    [LOCALE.Vietnam]: {
        dateFormat: 'DD/MM/YYYY',
        separator: ',',
    },
    [LOCALE.Cambodia]: {
        dateFormat: 'DD/MM/YYYY',
        separator: '.',
    },
    [LOCALE.India]: {
        dateFormat: 'DD/MM/YYYY',
        separator: '.',
    },
    [LOCALE.Indonesia]: {
        dateFormat: 'DD/MM/YYYY',
        separator: ',',
    },
    [LOCALE.Malaysia]: {
        dateFormat: 'DD/MM/YYYY',
        separator: '.',
    },
    [LOCALE.Thailand]: {
        dateFormat: 'DD/MM/YYYY',
        separator: '.',
    },
    [LOCALE.Taiwan]: {
        dateFormat: 'YYYY/MM/DD',
        separator: ',',
    },
    [LOCALE.China]: {
        dateFormat: 'YYYY/MM/DD',
        separator: ',',
    },
    [LOCALE.PhilippinesTagalog]: {
        dateFormat: 'MM/DD/YYYY',
        separator: '.',
    },
    [LOCALE.PhilippinesEnglish]: {
        dateFormat: 'MM/DD/YYYY',
        separator: '.',
    },
    [LOCALE.Myanmar]: {
        dateFormat: 'DD/MM/YYYY',
        separator: ',',
    },
};
const BEARER_TOKEN_COOKIE = 'hhg_user_token';
const BEARER_REFRESH_TOKEN_COOKIE = 'hhg_user_refresh_token';
const DATE_FNS_LOCALE = {
    [LOCALE.PhilippinesEnglish]: enUS,
    [LOCALE.Vietnam]: vi,
    [LOCALE.Cambodia]: km,
    [LOCALE.India]: hi,
    [LOCALE.Indonesia]: id,
    [LOCALE.Myanmar]: enUS,
    [LOCALE.Malaysia]: ms,
    [LOCALE.Thailand]: th,
    [LOCALE.Taiwan]: zhTW,
};
const CDN_ADDRESS = 'https://cdn.hellohealthgroup.com/countries';
const GA_TOKEN_COOKIE = '_ga';
const API_DATE_FORMAT = 'YYYY-MM-DD';
const DATE_FNS_DATE_FORMAT = 'dd-MM-yyyy';
const ZINDEX_SSO = 9999999;
const VIDEO_DETAIL_TEMP_STORAGE = 'video_item_detail';

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  basePath: basePath,
  SSO_URL: SSO_URL,
  USER_GEOLOCATION_COORDINATES_COOKIE: USER_GEOLOCATION_COORDINATES_COOKIE,
  LOCALE_SPECS: LOCALE_SPECS,
  STATIC_PAGES: STATIC_PAGES,
  UP_BASEPATH: UP_BASEPATH,
  TOGETHER_LOCALES: TOGETHER_LOCALES,
  ECOM_LOCALES: ECOM_LOCALES,
  DATA_PRIVACY_LOCALES: DATA_PRIVACY_LOCALES,
  CARE_LOCALES: CARE_LOCALES,
  CARE_BOOKING_LOCALES: CARE_BOOKING_LOCALES,
  VIDEO_LOCALES: VIDEO_LOCALES,
  FAVICONS: FAVICONS,
  get QUERY_HEALTH_TOOL () { return QUERY_HEALTH_TOOL; },
  ISO_FORMAT: ISO_FORMAT,
  BEARER_TOKEN_COOKIE: BEARER_TOKEN_COOKIE,
  BEARER_REFRESH_TOKEN_COOKIE: BEARER_REFRESH_TOKEN_COOKIE,
  DATE_FNS_LOCALE: DATE_FNS_LOCALE,
  CDN_ADDRESS: CDN_ADDRESS,
  GA_TOKEN_COOKIE: GA_TOKEN_COOKIE,
  API_DATE_FORMAT: API_DATE_FORMAT,
  DATE_FNS_DATE_FORMAT: DATE_FNS_DATE_FORMAT,
  ZINDEX_SSO: ZINDEX_SSO,
  VIDEO_DETAIL_TEMP_STORAGE: VIDEO_DETAIL_TEMP_STORAGE,
  siteHost: siteHost,
  siteOptions: siteOptions,
  domainLocales: domainLocales,
  MAP_DOMAIN_BY_LOCALE: MAP_DOMAIN_BY_LOCALE,
  get RISK_SCREENER_NAME () { return RISK_SCREENER_NAME; },
  RISK_SCREENER_SLUG: RISK_SCREENER_SLUG,
  isProduction: isProduction
});

export { API_DATE_FORMAT as A, BEARER_TOKEN_COOKIE as B, CDN_ADDRESS as C, DATA_PRIVACY_LOCALES as D, ECOM_LOCALES as E, FAVICONS as F, GA_TOKEN_COOKIE as G, ISO_FORMAT as I, LOCALE_SPECS as L, QUERY_HEALTH_TOOL as Q, STATIC_PAGES as S, TOGETHER_LOCALES as T, USER_GEOLOCATION_COORDINATES_COOKIE as U, VIDEO_DETAIL_TEMP_STORAGE as V, ZINDEX_SSO as Z, CARE_LOCALES as a, CARE_BOOKING_LOCALES as b, VIDEO_LOCALES as c, DATE_FNS_LOCALE as d, BEARER_REFRESH_TOKEN_COOKIE as e, basePath as f, SSO_URL as g, UP_BASEPATH as h, index as i, DATE_FNS_DATE_FORMAT as j };
